import React from 'react';
import { Link } from 'react-router-dom';
export const Footer = () => {
  return <footer className="w-full py-12 px-6 md:px-12 bg-gray-50 border-t border-gray-200 transition-colors" data-id="element-17">
      <div className="max-w-7xl mx-auto" data-id="element-18">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-19">
          <div className="mb-6 md:mb-0" data-id="element-20">
            <Link to="/" className="flex items-center" data-id="element-21">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9QqUfvRDGwG7W9qysjtvXP/RC-Logo_01-PositiveRGB.png" alt="Race Capital Logo" className="h-10" data-id="element-22" />
            </Link>
          </div>
          <div className="flex space-x-6" data-id="element-23">
            <a href="#" className="text-[#070707] hover:text-red-600 transition-colors" data-id="element-24">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" data-id="element-25">
                <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" data-id="element-26"></path>
              </svg>
            </a>
            <a href="#" className="text-[#070707] hover:text-red-600 transition-colors" data-id="element-27">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" data-id="element-28">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" data-id="element-29"></path>
                <rect x="2" y="9" width="4" height="12" data-id="element-30"></rect>
                <circle cx="4" cy="4" r="2" data-id="element-31"></circle>
              </svg>
            </a>
            <a href="#" className="text-[#070707] hover:text-red-600 transition-colors" data-id="element-32">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" data-id="element-33">
                <circle cx="12" cy="12" r="10" data-id="element-34"></circle>
                <circle cx="12" cy="12" r="4" data-id="element-35"></circle>
                <line x1="21.17" y1="8" x2="12" y2="8" data-id="element-36"></line>
                <line x1="3.95" y1="6.06" x2="8.54" y2="14" data-id="element-37"></line>
                <line x1="10.88" y1="21.94" x2="15.46" y2="14" data-id="element-38"></line>
              </svg>
            </a>
          </div>
        </div>
        <div className="mt-8 text-center md:text-left" data-id="element-39">
          <p className="text-[#070707] transition-colors" data-id="element-40">
            © 2025 Race Capital
          </p>
        </div>
      </div>
    </footer>;
};